import React,{ useEffect, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { makeStyles } from '@material-ui/core/styles';
import { sendGetRequest, cancelGetRequest } from '../utils/api';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/ArrowDownward';
import KeyboardArrowUpIcon from '@material-ui/icons/ArrowUpward';
import LaunchOutlinedIcon from '@material-ui/icons/LaunchOutlined';
import { Link } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});


function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(false);
    const classes = useRowStyles();
    var   path = 'tools'//useRouteMatch(); 
  
return (
<React.Fragment>
        <TableRow className={classes.root}>
        <TableCell style={{ fontWeight:'bold',padding: 8 }} >
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>{row.config}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div" style={{ fontWeight:'bold',fontSize:16,color:'cadetblue'}}>
                Configuration Details
              </Typography>
              <Table size="small" aria-label="apprv" style={{border:'1px solid rgba(224, 224, 224, 1)'}}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Configuration Name</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Update By</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Update Date</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {row.child
                .map((childRow) => (
                    <TableRow>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.configName}</TableCell>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.updateBy}</TableCell>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.updateDate}</TableCell>
                      <TableCell>
                      <IconButton
							           variant="contained"
								         color="primary"
								         component={Link}
								         to={`${path}/${childRow.idMaster}`}
							        ><LaunchOutlinedIcon />
							        </IconButton>
                      </TableCell>
                    </TableRow>
                ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>            
</React.Fragment>
	);
}


Row.propTypes = {
  row: PropTypes.shape({
    child: PropTypes.arrayOf(
      PropTypes.shape({
        configType: PropTypes.number.isRequired,  
        configName: PropTypes.number.isRequired,
        updateBy: PropTypes.number.isRequired,
        updateDate: PropTypes.number.isRequired,
      }),
    ).isRequired,
    config: PropTypes.string.isRequired,
  }).isRequired,
};

export default function WorkflowTable(){
    console.log("WORKFLOWTABLE LOAD")
    const [config,setConfig] = React.useState( [] );
    const [dept,setDept] = React.useState( [] ); 
    const [bu,setBU] = React.useState( [] ); 

	    const getTableData = async () => {
		  const table = 'inactive?type=config'
			const path = `/${table}`
			const res = await sendGetRequest(path);
			setConfig(res.data);
	
			if (res.error) {
                console.log(res.error.message);
				return;
			}
			console.log("DATA FETCHED FROM THE SERVER: ", res.data)
		
	  };

      const getDeptData = async () => {
        const table = 'inactive?type=dept'
          const path = `/${table}`
          const res = await sendGetRequest(path);
          setDept(res.data);
  
          if (res.error) {
              console.log(res.error.message);
              return;
          }
          console.log("DATA FETCHED FROM THE SERVER: ", res.data)
      
    }; 


    const getBUData = async () => {
        const table = 'inactive?type=bu'
          const path = `/${table}`
          const res = await sendGetRequest(path);
          setBU(res.data);
  
          if (res.error) {
              console.log(res.error.message);
              return;
          }
          console.log("DATA FETCHED FROM THE SERVER: ", res.data)
      
    }; 

  React.useEffect(() => {
		    getTableData();
        getDeptData();
        getBUData();
	}, []); 

  
const hier = [];
config.map(rows => {
       hier.push({"id":rows.configType,"pid":0,"config":rows.configType});
});

 config.map(rows => {
      hier.push({"pid":rows.configType, "configType":rows.configType,
                "configName":rows.configName, "idMaster" : rows.idMaster,
                "updateBy": rows.updateBy, "updateDate":rows.updateDate }) 
});

const arrComp= Array.from(new Set(hier.map(JSON.stringify))).map(JSON.parse);
//console.log(arrComp);


var tree = function (data, root) {
        var r = [], o = {};
        data.forEach(function (a) {
            if (o[a.id] && o[a.id].child) {
                a.child = o[a.id] && o[a.id].child;
            }
            o[a.id] = a;
            if (a.pid === root) {
                r.push(a);
            } else {
                o[a.pid] = o[a.pid] || {};
                o[a.pid].child = o[a.pid].child || [];
                o[a.pid].child.push(a);
            }
        });
        return r;
    }(arrComp, 0);

   console.log(tree);

   var   path = 'dept'//useRouteMatch(); 
   var   path1 = 'bu'//useRouteMatch(); 
   const [open, setOpen] = React.useState(false);
   const [open1, setOpen1] = React.useState(false);
   const classes = useRowStyles();

  return(
    <TableContainer component={Paper}>
    <Table aria-label="collapsible table">
      <TableHead>
        <TableRow style={{padding:15,color:'#fff', backgroundColor:'#3f51b5' }}>
          <TableCell align='left' style={{fontWeight:'bold', color:'#fff'}}>
           Inactive Configuration Types</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody> 
      {tree.map((row) => (
            <Row key={row.configType} row={row} />
          ))}
</TableBody>
</Table>

<Table aria-label="collapsible table">
      <TableHead>
        <TableRow style={{padding:15,color:'#fff', backgroundColor:'#3f51b5' }}>
          <TableCell align='left' style={{fontWeight:'bold', color:'#fff'}}>
           Inactive Departments</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody> 
    
        <TableRow className={classes.root}>
        <TableCell style={{ fontWeight:'bold',padding: 8 }} >
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>View Records
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="apprv" style={{border:'1px solid rgba(224, 224, 224, 1)'}}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Department</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Oracle Map</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Update By</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Update Date</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {dept.map((childRow) => (
                    <TableRow>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.deptName}</TableCell>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.orclMap}</TableCell>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.updateBy}</TableCell>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.updateDate}</TableCell>
                      <TableCell>
                      <IconButton
							           variant="contained"
								         color="primary"
								         component={Link}
								         to={`${path}/${childRow.idMaster}`}
							        ><LaunchOutlinedIcon />
							        </IconButton>
                      </TableCell>
                    </TableRow>
                ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>            
    </TableBody>
  </Table>

  <Table aria-label="collapsible table">
      <TableHead>
        <TableRow style={{padding:15,color:'#fff', backgroundColor:'#3f51b5' }}>
          <TableCell align='left' style={{fontWeight:'bold', color:'#fff'}}>
           Inactive Business Units</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody> 
    
        <TableRow className={classes.root}>
        <TableCell style={{ fontWeight:'bold',padding: 8 }} >
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen1(!open1)}>
            {open1 ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>View Records
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open1} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="apprv" style={{border:'1px solid rgba(224, 224, 224, 1)'}}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Business Unit</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Update By</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Update Date</TableCell>
                    <TableCell style={{ fontWeight:'bold',padding:10,color:'#fff', backgroundColor:'cadetblue' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {bu.map((childRow) => (
                    <TableRow>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.companyName}</TableCell>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.updateBy}</TableCell>
                      <TableCell style={{borderRight:'1px solid rgba(224, 224, 224, 1)'}}>{childRow.updateDate}</TableCell>
                      <TableCell>
                      <IconButton
							           variant="contained"
								         color="primary"
								         component={Link}
								         to={`${path}/${childRow.idMaster}`}
							        ><LaunchOutlinedIcon />
							        </IconButton>
                      </TableCell>
                    </TableRow>
                ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>            
    </TableBody>
  </Table>
</TableContainer>

)}